export enum DataHooks {
  OVERLAPPING = 'service-card-overlapping',
  STRIP = 'service-card-strip',
  CARD = 'service-card-default-card',
}
